import { Loading } from "components/shared";
import MySocialIcon from "components/shared/MySocialIcon";
import { Button, Dropdown, Tooltip } from "components/ui";
import capitalize from "components/ui/utils/capitalize";
import { PLACEMENT } from "components/ui/utils/constant";
import { useEffect, useState } from "react";
import { BsStars } from "react-icons/bs";
import { HiDotsHorizontal, HiOutlineX } from "react-icons/hi";
import { HiExclamationTriangle, HiOutlineTrash } from "react-icons/hi2";
import { TbStars, TbTrash } from "react-icons/tb";
import usePostGenerator from "utils/hooks/usePostGenerator";
import usePostValidator from "utils/hooks/usePostValidator";

const PostArticleSocialCreated = ({
    network,
    activeSocialNetwork,
    setActiveSocialNetwork,
    onDeleteNetworkPost,
    onReplaceNetworkPost,
    networkValidationErrors,
    networkPosts,
    isEditable,
    posts,
    postGroup
}) => {

    const { generateFromOtherPost } = usePostGenerator();
    const [ isLoading, setIsLoading ] = useState(false);

    const hasErrors = postGroup?.posts?.filter(p => p.social_network_type == network && p.status == "error" && !!p.status_message)?.length > 0;

    const onGenerateFromPost = async () => {
        setIsLoading(true);
        try {
            const basePost = posts?.[0];
            const newPost = await generateFromOtherPost(network, basePost?.text, basePost?.assets, basePost?.preferences?.media_product_type);
            onReplaceNetworkPost(network, {...newPost?.posts?.[0]});
        } catch (err) {
            console.error(err);
        }
        setIsLoading(false);
    }

    return (
        <div className={`relative max-w-[50%] !h-full !cursor-pointer flex items-center justify-center ${activeSocialNetwork == network ? `bg-secondary-500 dark:bg-gray-800` : `!bg-secondary-300 dark:!bg-gray-700`}`}>
            <div className={`group w-full !h-full px-4 py-3 flex-1 flex items-center justify-center hover:brightness-[1.1] hover:shadow-xl ${network == activeSocialNetwork ? `!shadow-xl` : ``} hover:z-[10]`} onClick={() => network != activeSocialNetwork && setActiveSocialNetwork(network)}>
                <span className={`shrink-0 relative rounded-full hover:z-[11] hover:shadow-xl hover:z-[10] ${network == activeSocialNetwork && `!shadow-xl`}`}>
                    <MySocialIcon network={network} className={`shadow !w-6 !h-6 lg:[.fullScreen_&]:!w-8 lg:[.fullScreen_&]:!h-8 !cursor-pointer transition-all !rounded-full group-hover:!shadow-xl`} />
                    {isLoading && (
                        <div className="flex items-center justify-center absolute left-0 top-0 w-full h-full rounded-full">
                            <Loading type="element" size="30" />
                        </div>
                    )}
                </span>
                <span 
                    className={`${network == activeSocialNetwork ? `max-w-[200px] ml-1.5` : `max-w-[0px]`} font-semibold text-tertiary-600 dark:text-gray-200 shrink-0 truncate transition-all flex items-center`}
                >
                    <span>{capitalize(network)}</span>
                    {activeSocialNetwork == network && isEditable && (
                        <div className="flex items-center justify-center gap-0">
                            <Tooltip title="AI: Format post for this network" wrapperClass="ml-1 relative hover:z-[10]">
                                <Button     
                                    color="red"
                                    size="sm"
                                    shape="circle"
                                    className="!bg-transparent hover:bg-fuchsia-600/20 relative hover:text-fuchsia-600 !rounded-full"
                                    icon={<BsStars className="text-lg" />}
                                    onClick={() => onGenerateFromPost()}
                                    loading={isLoading}
                                />
                            </Tooltip>
                            <Tooltip title="Delete post" wrapperClass="relative hover:z-[10] -mr-2">
                                <Button
                                    color="red"
                                    size="sm"
                                    shape="circle"
                                    className="!bg-transparent hover:bg-red-600/20 relative hover:text-red-600 !rounded-full -ml-2"
                                    icon={<TbTrash className="text-lg" />}
                                    onClick={() => onDeleteNetworkPost(network)}
                                />
                            </Tooltip>
                        </div>
                    )}
                </span>
                {!!networkValidationErrors?.length && !hasErrors ? (
                    <Tooltip 
                        title={`${capitalize(network)} post has validation errors`}
                        placement={"right"}
                        wrapperClass="absolute bottom-0 left-0 w-full h-1 bg-yellow-400"
                    />
                ) : !!hasErrors ? (
                    <Tooltip 
                        title={`${capitalize(network)} post has publishing errors`}
                        placement={"right"}
                        wrapperClass="absolute bottom-0 left-0 w-full h-1 bg-red-400"
                    />
                ) : network != activeSocialNetwork && (
                    <div className="absolute bottom-0 left-0 w-full h-[1px] bg-secondary-300 dark:bg-gray-800"></div>
                )}
            </div>
        </div>
    )
}

export default PostArticleSocialCreated;